module.exports = __webpack_public_path__ + "static/hero-about-5aef2da18250ab033346d9ce0e028e9a.jpg";